import { FunctionComponent, ReactElement, useCallback } from "react";
import { Amount } from "../../../../../../components";
import { colors } from "../../../../../../styles/colors";
import { Icon, Progress } from "../../../../../../ui";
import styles from "./ExpenseCategory.module.scss";
import { IExpenseCategoryProps } from "./types";

export const ExpenseCategory: FunctionComponent<IExpenseCategoryProps> = (
  props: IExpenseCategoryProps
): ReactElement<IExpenseCategoryProps> => {
  const { expenseCategory, onPress, ...restProps } = props;

  const doPress = useCallback(() => {
    onPress(expenseCategory);
  }, [expenseCategory, onPress]);

  return (
    <div className="col-lg-3 cardCol">
      <div className="card smallCard mainBlockBg" onClick={doPress}>
        <Icon
          backgroundColor={colors.palette.white}
          className={styles.iconDefault}
          color={colors.palette.black}
          icon={expenseCategory.icon}
          size={32}
        >
          <Progress.Circle
            backgroundColor={colors.palette.white}
            color={
              expenseCategory.limitation && !expenseCategory.balance
                ? colors.palette.white
                : expenseCategory.color
            }
            value={expenseCategory.balance}
            total={expenseCategory.limitation}
          />
        </Icon>
        <div className="cardContent">
          <Amount
            className="cardContentValue"
            currency={expenseCategory.currency}
            value={expenseCategory.balance}
          />
          <span className="cardContentLabel">{expenseCategory.name}</span>
        </div>
      </div>
    </div>
  );
};
